/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { AbstractControl, ValidatorFn } from '@angular/forms'
import { parsePhoneNumber } from 'awesome-phonenumber'
import { PhoneCommunicationDto } from '../../../../../apps/myprofile-ui/src/app/services/phone/phone.service'

export function duplicateNumber(phones: PhoneCommunicationDto[], phoneIdBeingEdited: string, preparePayloadFunction: any): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    if (!control.value) {
      // required validator kicks in
      return null
    }

    const controlNumberWithoutSpecialChars = preparePayloadFunction(control.value)
    const num1 = parsePhoneNumber(controlNumberWithoutSpecialChars)
    const existingPhone = phones.filter(
      (phone) =>
        !!phone.number && parsePhoneNumber(phone.number).number?.national === num1.number?.national && phoneIdBeingEdited !== phone.id,
    )
    if (existingPhone.length !== 0) {
      return { duplicateNumber: true }
    }

    return null
  }
}
